import { getCampaignEditorUrl } from 'utils/appRoutes';
import { Campaign } from '../domainTypes';
import { NameLink } from './CampaignNameCell.styles';

/** This should be temporary and we can inline this into the CampaignNameCell once we are removing the old code path. */
export const CampaignNameNav = ({
  campaign,
  children,
  isCampaignReactificationFeatureOn,
  isCampaignAnalyticsReactificationFeatureOn,
}: {
  children: React.ReactChild | React.ReactChild[];
  campaign: Campaign;
  isCampaignReactificationFeatureOn: boolean;
  isCampaignAnalyticsReactificationFeatureOn: boolean;
}) => {
  const url = getCampaignEditorUrl(campaign, {
    isCampaignReactificationFeatureOn,
    isCampaignAnalyticsReactificationFeatureOn,
  });
  return <NameLink href={url}>{children}</NameLink>;
};
